import { render } from "./ImageUpload.vue?vue&type=template&id=06acfe12"
import script from "./ImageUpload.vue?vue&type=script&lang=js"
export * from "./ImageUpload.vue?vue&type=script&lang=js"

import "./ImageUpload.vue?vue&type=style&index=0&id=06acfe12&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__